import HomePage from './views/Home';
import SelectPage from './views/Select';
import StageSelectPage from './views/StageSelect';
import DescPage from './views/Desc';
import DroneGamePage from './views/DroneGame';
import AttackGamePage from './views/AttackGame';
import ScorePage from './views/Score';
import RewardPage from './views/Reward';
import IntroPage from './views/Intro';
import GameIntroPage from './views/GameIntro';

export default [
    { name: 'home-page', path: '/', exact: true, Component: HomePage },
    { name: 'select-page', path: '/select', Component: SelectPage },
    { name: 'stage-select-page', path: '/stage-select', Component: StageSelectPage },
    { name: 'desc-page', path: '/desc', Component: DescPage }, 
    { name: 'drone-page', path: '/drone', Component: DroneGamePage },
    { name: 'attack-page', path: '/attack', Component: AttackGamePage },
    { name: 'score-page', path: '/score', Component: ScorePage },
    { name: 'reward-page', path: '/reward', Component: RewardPage },
    { name: 'intro-page', path: '/intro', Component: IntroPage },
    { name: 'game-intro-page', path: '/game-intro', Component: GameIntroPage }
];